/* tslint:disable */
/* eslint-disable */
/**
 * Pricing API
 * API for managing pricing.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConfigurableParameterDto1 } from './ConfigurableParameterDto1';
import {
    ConfigurableParameterDto1FromJSON,
    ConfigurableParameterDto1FromJSONTyped,
    ConfigurableParameterDto1ToJSON,
    ConfigurableParameterDto1ToJSONTyped,
} from './ConfigurableParameterDto1';

/**
 * 
 * @export
 * @interface VariablesDto
 */
export interface VariablesDto {
    /**
     * Unique identifier of the variable value Id
     * @type {string}
     * @memberof VariablesDto
     */
    variableValueId: string;
    /**
     * Unique identifier of the variable ref Id
     * @type {string}
     * @memberof VariablesDto
     */
    variableRefId: string;
    /**
     * The numeric value of the variable
     * @type {number}
     * @memberof VariablesDto
     */
    value: number;
    /**
     * The code or key identifier for the variable
     * @type {string}
     * @memberof VariablesDto
     */
    code: string;
    /**
     * The human-readable label or name of the variable
     * @type {string}
     * @memberof VariablesDto
     */
    label: string;
    /**
     * 
     * @type {ConfigurableParameterDto1}
     * @memberof VariablesDto
     */
    parameters?: ConfigurableParameterDto1;
    /**
     * 
     * @type {string}
     * @memberof VariablesDto
     */
    warningMessage?: string;
}

/**
 * Check if a given object implements the VariablesDto interface.
 */
export function instanceOfVariablesDto(value: object): value is VariablesDto {
    if (!('variableValueId' in value) || value['variableValueId'] === undefined) return false;
    if (!('variableRefId' in value) || value['variableRefId'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function VariablesDtoFromJSON(json: any): VariablesDto {
    return VariablesDtoFromJSONTyped(json, false);
}

export function VariablesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): VariablesDto {
    if (json == null) {
        return json;
    }
    return {
        
        'variableValueId': json['variableValueId'],
        'variableRefId': json['variableRefId'],
        'value': json['value'],
        'code': json['code'],
        'label': json['label'],
        'parameters': json['parameters'] == null ? undefined : ConfigurableParameterDto1FromJSON(json['parameters']),
        'warningMessage': json['warningMessage'] == null ? undefined : json['warningMessage'],
    };
}

export function VariablesDtoToJSON(json: any): VariablesDto {
    return VariablesDtoToJSONTyped(json, false);
}

export function VariablesDtoToJSONTyped(value?: VariablesDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'variableValueId': value['variableValueId'],
        'variableRefId': value['variableRefId'],
        'value': value['value'],
        'code': value['code'],
        'label': value['label'],
        'parameters': ConfigurableParameterDto1ToJSON(value['parameters']),
        'warningMessage': value['warningMessage'],
    };
}

